<template>
  <div class="amount_pie_wrap">
    <div class="amount" :style="{ marginTop: headerHeight + 34 + 'px' }">
      <div class="amount_title">
        <div class="amount_icon">
          <img src="../../imgs/member_logo.png" alt="" />
        </div>
        {{ $t('FoodC_bill_VODO_nrnN') }}
      </div>
      <div class="amount_value">{{ savingMoneyCount.totalSavingMoneyTran }}</div>
    </div>
    <pie v-if="isShowPie" :savingMoneyCount="savingMoneyCount" />
  </div>
</template>

<script>
import mixin from '@/page/member/mixins.js'
import pie from './pie.vue'
import ImmersionHeader from '@/components/immersionHeader/index.vue'
export default {
  name: 'MemberCard',
  components: {
    pie,
    ImmersionHeader,
  },
  mixins: [mixin],
  props: {
    headerHeight: {
      type: Number,
      default: 0,
    },
    savingMoneyCount: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {}
  },
  computed: {
    isShowPie() {
      return this.savingMoneyCount?.totalSavingMoneyTran
    },
  },
  mounted() {},
  created() {},
  methods: {},
}
</script>

<style lang="scss" scoped>
.amount_pie_wrap {
  background-image: url('../../imgs/member_bg.png');
  background-size: 100% 100%;
  background-repeat: no-repeat;
  padding: 0 40px;
  height: 1029px;
  overflow: hidden;
  .amount {
    margin-top: 48px;
    .amount_title {
      display: flex;
      justify-content: center;
      align-items: center;
      font-family: DiDiSans-Pro-Bold;
      font-size: 32px;
      color: #ffffff;
      letter-spacing: 0;
      line-height: 40px;
      .amount_icon {
        width: 50px;
        height: 40px;
        margin-right: 12px;
        img {
          width: 100%;
          height: 100%;
        }
      }
    }
    .amount_value {
      margin-top: 12px;
      font-family: DiDiSans-Pro-ExtraBoldTest;
      font-size: 72px;
      color: #ffffff;
      letter-spacing: 0;
      line-height: 88px;
      text-align: center;
    }
  }
}
</style>
